"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLAIR_BADGE_NAME_REGEX = exports.PROTECTED_EMAIL_DOMAINS = exports.DEFAULT_AUTO_ARCHIVE_OLDER_THAN = exports.REDIRECT_TO_PARAM = exports.MAX_DSA_ADDITIONAL_COMMENT_URL_LENGTH = exports.MAX_DSA_ADDITIONAL_INFO_LENGTH = exports.MAX_DSA_LAW_BROKEN_LENGTH = exports.MAX_BIO_LENGTH = exports.LINK_CLASSNAME = exports.SARCASM_CLASSNAME = exports.SPOILER_CLASSNAME = exports.COMMENT_REPEAT_POST_DURATION = exports.DEFAULT_SESSION_DURATION = exports.SCHEDULED_DELETION_WINDOW_DURATION = exports.ALLOWED_USERNAME_CHANGE_TIMEFRAME_DURATION = exports.DOWNLOAD_LIMIT_TIMEFRAME_DURATION = exports.GIPHY_FETCH = exports.GIPHY_SEARCH = exports.TOXICITY_ENDPOINT_DEFAULT = exports.TOXICITY_MODEL_DEFAULT = exports.TOXICITY_THRESHOLD_DEFAULT = exports.ACCESS_TOKEN_PARAM = exports.BUNDLE_CONFIG_PARAM = exports.BUNDLE_ID_PARAM = exports.CLIENT_ID_PARAM = exports.CLIENT_ID_HEADER = void 0;
const ms_1 = __importDefault(require("ms"));
const time_1 = __importDefault(require("./time"));
/**
 * CLIENT_ID_HEADER references the name of the header used to extract/send the
 * client ID to enable automatic de-duplication.
 */
exports.CLIENT_ID_HEADER = "X-Coral-Client-ID";
/**
 * CLIENT_ID_PARAM references the name of the param used to send the client ID
 * via connectionParams when authenticating a websocket connection to enable
 * automatic de-duplication.
 */
exports.CLIENT_ID_PARAM = "clientID";
/**
 * BUNDLE_ID_PARAM references the name of the param used ot send the ID of the
 * bundle via connectionParams when connecting via a websocket connection.
 */
exports.BUNDLE_ID_PARAM = "bundleID";
/**
 * BUNDLE_CONFIG_PARAM references the name of the param used to send the
 * parameters of the bundle via connectionParams when connecting via a websocket
 * connection.
 */
exports.BUNDLE_CONFIG_PARAM = "bundleConfig";
/**
 * ACCESS_TOKEN_PARAM references the name of the param used to send the access
 * token in connectionParams when authenticating a websocket connection.
 */
exports.ACCESS_TOKEN_PARAM = "accessToken";
/**
 * TOXICITY_THRESHOLD_DEFAULT is the default value used when the threshold is
 * not set.
 */
exports.TOXICITY_THRESHOLD_DEFAULT = 80;
/**
 * TOXICITY_MODEL_DEFAULT is the default value used for the toxicity model.
 */
exports.TOXICITY_MODEL_DEFAULT = "TOXICITY";
/**
 * TOXICITY_ENDPOINT_DEFAULT is the default value used for the toxicity endpoint
 * for the API.
 */
exports.TOXICITY_ENDPOINT_DEFAULT = "https://commentanalyzer.googleapis.com/v1alpha1";
exports.GIPHY_SEARCH = "https://api.giphy.com/v1/gifs/search";
exports.GIPHY_FETCH = "https://api.giphy.com/v1/gifs";
/**
 * DOWNLOAD_LIMIT_TIMEFRAME_DURATION is the number of seconds that a given
 * download may be made within.
 */
exports.DOWNLOAD_LIMIT_TIMEFRAME_DURATION = 14 * time_1.default.DAY;
/**
 * ALLOWED_USERNAME_CHANGE_TIMEFRAME_DURATION is the length of time in seconds
 * a user must wait after changing their username to change it again.
 */
exports.ALLOWED_USERNAME_CHANGE_TIMEFRAME_DURATION = 14 * time_1.default.DAY;
/**
 * SCHEDULED_DELETION_TIMEFRAME is the length of time in seconds a user will
 * have to wait for their account to be deleted after requesting a deletion.
 */
exports.SCHEDULED_DELETION_WINDOW_DURATION = 1 * time_1.default.DAY;
/**
 * DEFAULT_SESSION_DURATION is the length of time in seconds a session is valid
 * for unless configured in tenant.
 */
exports.DEFAULT_SESSION_DURATION = 90 * time_1.default.DAY;
/**
 * COMMENT_REPEAT_POST_DURATION is the length of time in seconds that a
 * previous comment ID is stored for a user to prevent them from posting the
 * same comment repeatedly.
 */
exports.COMMENT_REPEAT_POST_DURATION = 6 * time_1.default.MINUTE;
/**
 * SPOILER_CLASSNAME is the classname that is attached to spoilers.
 */
exports.SPOILER_CLASSNAME = "coral-rte-spoiler";
/**
 * SARCASM_CLASSNAME is the classname that is attached to sarcasm.
 */
exports.SARCASM_CLASSNAME = "coral-rte-sarcasm";
/**
 * LINK_CLASSNAME is the classname that is attached to links within comments.
 */
exports.LINK_CLASSNAME = "coral-comment-content-link";
/**
 * MAX_BIO_LENGTH is the maximum length of a user bio in characters
 */
exports.MAX_BIO_LENGTH = 100;
exports.MAX_DSA_LAW_BROKEN_LENGTH = 500;
exports.MAX_DSA_ADDITIONAL_INFO_LENGTH = 1000;
exports.MAX_DSA_ADDITIONAL_COMMENT_URL_LENGTH = 1000;
exports.REDIRECT_TO_PARAM = "redirectTo";
exports.DEFAULT_AUTO_ARCHIVE_OLDER_THAN = ms_1.default("120 days");
exports.PROTECTED_EMAIL_DOMAINS = new Set([
    "voxmedia.com",
    "gmail.com",
    "gmail.co.uk",
    "aol.com",
    "att.net",
    "duck.com",
    "verizon.net",
    "yahoo.com",
    "yahoo.co.nz",
    "yahoo.com.au",
    "yahoo.co.za",
    "xtra.co.nz",
    "btinternet.com",
    "yahoo.se",
    "comcast.net",
    "outlook.com",
    "icloud.com",
    "rr.com",
    "hotmail.com",
    "hotmail.co.uk",
    "hotmail.es",
    "hotmail.fr",
    "msn.com",
    "me.com",
    "live.co.uk",
    "live.com",
    "live.co.za",
    "rogers.com",
    "global.co.za",
    "ncacoral.com.au",
    "proton.me",
    "westnet.com.au",
    "laposte.net",
    "free.fr",
    "orange.fr",
    "outlook.fr",
    "yahoo.fr",
    "online.no",
    "live.no",
    "yahoo.no",
    "hotmail.no",
    "rr.com",
    "outlook.co.nz",
    "outlook.at",
    "outlook.in",
    "outlook.com.au",
    "outlook.fr",
    "outlook.de",
    "outlook.jp",
]);
exports.FLAIR_BADGE_NAME_REGEX = "^[\\w.-]+$";
